import LegalLayout from '../components/legal/LegalLayout'
import source, { VERSION, EFFECTIVE_DATE } from '../assets/legal/practicePrivacy'

// One document, one page, one chunk. See components/legal/LegalLayout.jsx for
// why these are not a single :slug route.

export default function LegalPrivacy() {
  return (
    <LegalLayout
      slug="privacy"
      title="Privacy Policy"
      version={VERSION}
      date={EFFECTIVE_DATE}
      source={source}
    />
  )
}
